import { render, staticRenderFns } from "./Appellation.vue?vue&type=template&id=1b9ee0ce"
import script from "./Appellation.vue?vue&type=script&lang=js"
export * from "./Appellation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports